<template>
  <div>
    <ValidationObserver ref="formValidator">
      <form novalidate action="validateStudent" @submit.prevent="onContinue">
        <div class="d-flex justify-content-center my-3">
          <div class="container-box-step2 text-center">
            <strong class="confirm-title">Confirmación del Estudiante</strong>
            <div class="sie-section mb-4 mt-4">
              <div class="row mb-3">
                <div class="col-12">
                  <div class="separator-custom">
                    <div class="text">
                      Número SIE
                    </div>
                  </div>
                </div>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                class="text-center"
              >
                <custom-input
                  v-model="info.studentSie"
                  :error="errors[0]"
                  custom-error-msg="El Número de SIE es requerido para continuar"
                  :disabled="wasStudentValidated"
                  class="custom-text-field pl-4 pr-4"
                />
              </ValidationProvider>
            </div>
            <div class="birthdate-section mb-4">
              <div class="row mb-3">
                <div class="col-12">
                  <div class="separator-custom">
                    <div class="text">
                      Fecha de Nacimiento
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-center align-items-center birthdate-input"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  class="custom-month-year-size"
                >
                  <custom-input
                    v-model="info.birthDay"
                    type="text"
                    input-mask="dayOrMonth"
                    :error="errors[0]"
                    placeholder="DD"
                    :disabled="wasStudentValidated"
                    class="custom-text-field custom-month-year-size"
                  />
                  <div class="row  position-absolute">
                    <div class="col-10">
                      <Error
                        v-if="errors[0]"
                        variant="no-border"
                        message="La Fecha de Nacimiento es requerida para continuar"
                      />
                    </div>
                  </div>
                </ValidationProvider>
                <span class="custom-slash">/</span>
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  class="custom-month-year-size"
                >
                  <custom-input
                    v-model="info.birthMonth"
                    :error="errors[0]"
                    placeholder="MM"
                    :disabled="wasStudentValidated"
                    class="custom-text-field "
                  />
                </ValidationProvider>
                <span class="custom-slash">/</span>
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="info.birthYear"
                    type="number"
                    :min="1900"
                    :max="birthYearMax"
                    :error="errors[0]"
                    placeholder="YYYY"
                    :disabled="wasStudentValidated"
                    class="custom-text-field textfield-year"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div
              v-if="confirmationNumber"
              class="way-section mb-4 mt-5 custom-invalid left-padding"
            >
              El cuestionario para el estudiante ya fue completado y su número
              de confirmación es {{ confirmationNumber }}. Para recibir
              asistencia en el proceso, se puede comunicar con el centro de
              apoyo al número (787) 585-8855.
            </div>
            <div
              v-if="wasStudentValidated && notificationWays.length > 1"
              class="way-section mb-4 mt-5 "
            >
              <p>
                Medio por el cual recibió la carta para completar el
                cuestionario.
              </p>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  v-model="info.selectedNotificationWay"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  :options="notificationWays"
                  fieldkey="id"
                  fieldname="name"
                  custom-error-msg="Campo requerido"
                />
              </ValidationProvider>
            </div>
            <div class="recaptcha-policy-section mt-5">
              <p>
                MiPE está protegido por reCAPTCHA bajo las
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Políticas de privacidad
                </a>
                y los
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Términos de servicio
                </a>
                .
              </p>
            </div>
            <div class="continue-section w-100">
              <action-button
                type="submit"
                variant="success custom-next-button"
                iright="fa fa-angle-double-right btn-lg"
              >
                Continuar
              </action-button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  CustomInput,
  CustomDropDown,
  ActionButton,
  Error,
} from '@/components/common';
import alertMixin from '@/mixin/alert.mixin';
import { modulesName } from '@/modules';
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { VUE_APP_RECAPTCHA_SITE_KEY } from '@/config';

const moduleName = modulesName.welcomePortalModuleName;
const { mapGetters, mapMutations, mapActions } = createNamespacedHelpers(
  moduleName
);

//add recaptcha plugin
Vue.use(VueReCaptcha, {
  siteKey: VUE_APP_RECAPTCHA_SITE_KEY,
});

export default {
  name: 'Tab2',
  mixins: [alertMixin],
  data: () => ({
    token: '',
    messages: {
      '0682':
        'El número de SIE y Fecha de Nacimiento son requeridos para continuar. Para recibir asistencia en el proceso se puede comunicar en el centro de apoyo al número 787-773-6147.',
      '0684':
        'El número de SIE y Fecha de Nacimiento no concuerdan con los datos en sistema. Para recibir asistencia en el proceso se puede comunicar en el centro de apoyo al número 787-773-6147.',
      '0685':
        'El cuestionario para el estudiante ya fue completado y su número de confirmación es 2019-00800. Para recibir asistencia en el proceso se puede comunicar en el centro de apoyo al número 787-773-6147.',
      '0686':
        'Favor de seleccionar el medio por el cual se le notificó que fue seleccionado.',
    },
  }),
  computed: {
    ...mapGetters({
      notificationWays: 'getNotificationWays',
      wasStudentValidated: 'getWasStudentValidated',
      studentValidationMessage: 'getStudentValidationMessage',
      confirmationNumber: 'getConfirmationNumber',
    }),
    info: {
      get() {
        return this.$store.state[moduleName].info;
      },
      set(value) {
        this.setInfo(value);
      },
    },
    birthYearMax() {
      return new Date().getFullYear();
    },
  },
  components: {
    CustomInput,
    CustomDropDown,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    Error,
  },
  methods: {
    ...mapMutations(['setInfo', 'setCurrentNotificationWay']),
    ...mapActions(['isSieValid', 'getNotificationWays', 'getQuestionnaire']),
    async onContinue() {
      const allValid = await this.$refs.formValidator.validate();
      if (allValid) {
        //valid date format
        const isDateValid = moment(this.getParsedBirthDate());
        if (!isDateValid.isValid()) {
          this.ShowToast(
            'Error',
            'El formato de fecha es invalido, debe introducir una fecha de nacimiento en formato Día/Mes/Año.',
            'error'
          );
          return;
        }

        if (!this.wasStudentValidated) {
          await this.isSieValid({
            studentSieId: this.info.studentSie,
            studentBirthDate: this.getParsedBirthDate(),
            token: this.token,
          });

          //get refresh token
          await this.recaptcha();

          //show invalid info
          if (!this.wasStudentValidated) {
            this.ShowToast('Error', this.studentValidationMessage, 'error');
            return;
          }

          //verify notification number
          if (this.confirmationNumber) {
            //move on to step 4
            this.$emit('select-tab', 2);

            //show toaster
            this.ShowToast('Alerta', this.studentValidationMessage, 'error');
            return;
          }

          //load get notification ways for the first time
          if (this.wasStudentValidated && !this.confirmationNumber) {
            await this.getNotificationWays({
              studentSieId: this.info.studentSie,
            });
            if (this.notificationWays.length > 1) {
              return;
            } else {
              this.setCurrentNotificationWay(this.notificationWays[0]);
            }
          }
          if (!this.confirmationNumber) {
            //get questionnaire
            await this.getQuestionnaire();
          }
          //if has only one row in notification way, go to step 2 automatically
          if (this.notificationWays.length <= 0) {
            this.$emit('select-tab', 3);
          }

          //move on
          this.$emit('select-tab', 3);
        } else {
          if (!this.confirmationNumber) {
            //get questionnaire
            await this.getQuestionnaire();
            //move on
            this.$emit('select-tab', 3);
          }
        }
      } else {
        //missing way
        if (this.wasStudentValidated) {
          this.ShowToast('Error', this.messages['0686'], 'error');
        } else {
          this.ShowToast('Error', this.messages['0682'], 'error');
        }
      }
    },
    getParsedBirthDate() {
      return `${this.info.birthYear}-${this.info.birthMonth}-${this.info.birthDay}`;
    },
    async recaptcha() {
      await this.$recaptchaLoaded();
      this.token = await this.$recaptcha('validateStudent');
    },
  },
  async created() {
    this.$nextTick(async () => {
      await this.recaptcha();
    });
  },
};
</script>

<style scoped lang="scss">
.custom-invalid {
  color: red;
  text-align: left;
  margin-left: 20px;
}
.container-box-step2 {
  max-width: 700px;
  background: #fafafa;
  border-radius: 5px;
  opacity: 1;
  padding: 30px;

  .confirm-title {
    text-align: center;
    font: Bold 24px/29px Lato;
    letter-spacing: 0px;
    color: #11291b;
  }

  ::v-deep .custom-title-divider {
    .title-content {
      background: none;
      color: #11291b;
      margin-left: 0px;
      margin-right: 0px;
    }
  }

  .birthdate-section {
    .custom-slash {
      margin: 5px 10px 10px 10px;
    }
  }

  .way-section {
    max-width: 322px;
    margin: auto auto;
  }

  .recaptcha-policy-section {
    max-width: 322px;
    margin-left: auto;
    margin-right: auto;
  }
}

.custom-text-field {
  ::v-deep .form-control:disabled {
    background: #e6e6e6 !important;
  }
}

.textfield-year {
  width: 140px;
}

.separator-custom {
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  font: 700 17px/23px Lato;
}
.separator-custom .text {
  color: #11291b;
  border-radius: 21px;
  padding: 5px 16px;
}
.separator-custom::before,
.separator-custom::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #b5c3bc;
}
.separator-custom::before {
  margin-right: 5px;
}
.separator-custom::after {
  margin-left: 5px;
}

.custom-month-year-size {
  max-width: 60px;
}
</style>
